import { isEmail } from 'validator';
import { isString } from 'lodash';

export class User {
  id: string
  username: string
  firstname: string
  lastname: string
  is_admin: boolean
  timezone: string
  created_at: number

  password: string

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  get fullname() {
    if(this.firstname && this.lastname) {
      return `${this.firstname} ${this.lastname}`;
    }
    else if(this.firstname) {
      return this.firstname;
    }
    else if(this.lastname) {
      return this.lastname;
    }
    else if(this.username) {
      return this.username;
    }
    else {
      return this.id;
    }
  }

  toUserInput() {
    return {
      username: this.username,
      password: this.password,
      firstname: this.firstname,
      lastname: this.lastname,
      timezone: this.timezone,
      is_admin: this.is_admin,
    };
  }

  toCurrentUserInput() {
    return {
      username: this.username,
      password: this.password,
      firstname: this.firstname,
      lastname: this.lastname,
      timezone: this.timezone,
    };
  }

  get valid():boolean {
    // username
    if(!isString(this.username)) {
      return false;
    }

    let trimmedUsername = this.username.trim();

    if(trimmedUsername.length > 50) {
      return false;
    }

    if(!isEmail(trimmedUsername)) {
      return false;
    }

    // password (validated only if set or the user is new)
    if((this.id && this.password) || !this.id) {
      if (!isString(this.password)) {
        return false;
      }

      let trimmedPassword = this.password.trim();

      if (trimmedPassword.length < 8 || trimmedPassword.length > 50) {
        return false;
      }
    }

    // firstname
    if(!isString(this.firstname)) {
      return false;
    }

    let trimmedFirstname = this.firstname.trim();

    if(trimmedFirstname.length < 1 || trimmedFirstname.length > 50) {
      return false;
    }

    // lastname
    if(!isString(this.lastname)) {
      return false;
    }

    let trimmedLastname = this.lastname.trim();

    if(trimmedLastname.length < 1 || trimmedLastname.length > 50) {
      return false;
    }

    return true;
  }
}
